import React, { useContext, useEffect, useState } from 'react';
import { FilterBarContext, FilterFieldName } from '../FilterBarContext';
import { Autocomplete, TextField } from '@mui/material';
import { balanceService } from '@/modules/balances/api/balances/balance.service';
import { BalancesAtLocationModel } from '@/modules/balances/models/BalanceAtLocationModel';

interface GuestLocationFilterProps {
  label: string;
}

const GuestLocationFilter: React.FC<GuestLocationFilterProps> = ({ label }) => {
  const { setFilterValue, filterValues } = useContext(FilterBarContext);
  const [locations, setLocations] = useState<BalancesAtLocationModel[]>([]);
  const [selectedLocation, setSelectedLocation] = useState<BalancesAtLocationModel | null>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    const loadAssignedLocations = async () => {
      setIsLoading(true);
      try {
        const response = await balanceService.getBalancesForLocations({});
        if (response.isSuccess) {
          setLocations(response.payload);

          // Set initial selection if there's a locationId in filterValues
          if (filterValues.locationId && response.payload.length > 0) {
            const location = response.payload.find((loc) => loc.dto.locationId === Number(filterValues.locationId));
            if (location) {
              setSelectedLocation(location);
            }
          }
        }
      } catch (error) {
        console.error('Error loading assigned locations:', error);
      } finally {
        setIsLoading(false);
      }
    };

    loadAssignedLocations();
  }, []);

  const handleLocationChange = (event: unknown, value: BalancesAtLocationModel | null) => {
    setSelectedLocation(value);
    if (value) {
      setFilterValue(FilterFieldName.locationId, value.dto.locationId, value.dto.locationName);
    } else {
      setFilterValue(FilterFieldName.locationId, undefined);
    }
  };

  return (
    <Autocomplete
      value={selectedLocation}
      onChange={handleLocationChange}
      options={locations}
      loading={isLoading}
      getOptionLabel={(option) => `${option.dto.locationName} (${option.dto.locationCode})`}
      isOptionEqualToValue={(option, value) => option.dto.locationId === value.dto.locationId}
      renderInput={(params) => (
        <TextField
          {...params}
          label={label}
          slotProps={{
            ...params.slotProps,
            inputLabel: { shrink: true },
          }}
        />
      )}
      className="w-full"
    />
  );
};

export default GuestLocationFilter;
